import type { DeviceInfo } from './captureRecord';

type NavLike = {
  userAgent?: string;
  platform?: string;
  userAgentData?: {
    mobile?: boolean;
    platform?: string;
    getHighEntropyValues?: (hints: string[]) => Promise<{ model?: string; platform?: string }>;
  };
};

/**
 * Phone identity for the SF-84 capture record. The model comes from UA Client
 * Hints, which Chromium on Android has and Safari does not; on iOS the UA plus
 * screen size and pixel ratio are what identify the phone.
 */
export async function readDeviceInfo(
  nav: NavLike,
  screen: { width: number; height: number },
  dpr: number,
): Promise<DeviceInfo> {
  const uad = nav.userAgentData;
  let model: string | null = null;
  let platform: string | null = uad?.platform || nav.platform || null;
  if (uad?.getHighEntropyValues) {
    try {
      const hev = await uad.getHighEntropyValues(['model', 'platform']);
      model = hev.model || null;
      platform = hev.platform || platform;
    } catch {
      model = null;
    }
  }
  return {
    userAgent: nav.userAgent ?? '',
    model,
    platform,
    mobile: typeof uad?.mobile === 'boolean' ? uad.mobile : null,
    screen: { width: screen.width, height: screen.height, dpr },
  };
}
